<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();

const isInboxSettingsRoute = computed(() =>
  route.path.includes('/settings/inboxes')
);
</script>

<template>
  <div
    class="flex flex-col w-full h-full min-h-0 m-0 overflow-auto bg-n-background font-inter"
    :class="{ 'inbox-white-surface': isInboxSettingsRoute }"
  >
    <div class="flex flex-1 items-stretch w-full h-full min-h-0">
      <router-view v-slot="{ Component }">
        <keep-alive v-if="keepAlive">
          <component :is="Component" />
        </keep-alive>
        <component :is="Component" v-else />
      </router-view>
    </div>
  </div>
</template>

<style scoped>
/* Force all settings pages to white background */
.bg-n-background {
  background: #ffffff !important;
}

.inbox-white-surface {
  background: #ffffff !important;
}

.inbox-white-surface :deep(.bg-n-background) {
  background: #ffffff !important;
}

.inbox-white-surface :deep(.text-n-slate-12) {
  color: #111827 !important;
}

.inbox-white-surface :deep(.text-n-slate-11),
.inbox-white-surface :deep(.text-n-slate-10),
.inbox-white-surface :deep(.text-n-slate-9) {
  color: #64748b !important;
}
</style>
